/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { SiteTrfProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const siteTrfProcessFetchSiteTrfProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const siteTrfProcessFetchSiteTrfProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [SiteTrfProcessTypes.SITE_TRF_PROCESS_FETCH_SITE_TRF_PROCESS_LOADING]: siteTrfProcessFetchSiteTrfProcessLoading,
  [SiteTrfProcessTypes.SITE_TRF_PROCESS_FETCH_SITE_TRF_PROCESS_SUCCESS]: siteTrfProcessFetchSiteTrfProcessSuccess
});
